// extracted by mini-css-extract-plugin
export default {"label":"EditZhuguan_label__in710","tip":"EditZhuguan_tip__g0xvO"};